import { APP_ROUTES } from '@/routes/routes.type';

/** Сегменты routerLink для публичной категории блога. */
export function blogCategoryLink(slug: string): string[] {
  return ['/', APP_ROUTES.BLOG, 'c', slug];
}
